// no itx for this file
import SettingsPage from "../components/SettingsPane/SettingsPage";
import Logger from "../Logger";
import Dropdown from "react-dropdown-select";
import { itx } from "../translationItx/itx";
import { useState } from "react";

export default function SettingPageLogging(props: {
  handler: string;
  dropDownColor: string;
  setRefresh?: (number: number) => void;
  refresh?: number;
}) {
  const { dropDownColor, setRefresh, refresh } = props;
  const [loggingFilter, setLoggingFilter] = useState("");

  function LoggerElements() {
    function HeaderRow(props: { loggerArray: Array<Logger>; groupname: string; step: number }) {
      const { loggerArray, groupname, step } = props;

      const headerLogger = { className: groupname, mode: "D" };

      function handleOnChange(ev: React.ChangeEvent<HTMLSelectElement>) {
        loggerArray.forEach((logger) => {
          (logger.mode as any) = ev.target.value;
          (document.getElementById(logger.className) as any).value = ev.target.value;
        });
      }
      const paddingLeft = `${step * 0.5 + 0.5}cm`;
      /// check if groupname is in allLoggerParents
      if (Logger.allLoggerParents.has(headerLogger.className)) {
        headerLogger.mode = Logger.allLoggerParents.get(groupname) as string;
      }

      return (
        <tr
          style={{
            backgroundColor: groupname == "All" ? "var(--backgroundColorDarkGrey)" : "var(--defaultBackgroundColor)", // no itx
            fontWeight: 500,
          }}
        >
          <td style={{ verticalAlign: "middle", paddingLeft: paddingLeft }}>
            {groupname != "All" && <span>&#x1F4C1;</span>}&nbsp;{groupname}
            {/* {groupname != "All" && <i className="las la-folder-open la-lg"></i>}&nbsp;{groupname}*/}
          </td>
          <td>
            <Dropdown
              name="logging"
              key={`${headerLogger.className}.${headerLogger.mode}`}
              className={`log-${groupname} form-dropdown no-top-margin input-small`}
              options={[
                { value: "O", label: "Off" }, // no itx
                { value: "D", label: "Debug" }, // no itx
                { value: "E", label: "Error" }, // no itx
              ]}
              values={[
                {
                  value: headerLogger.mode,
                  label: headerLogger.mode == "O" ? "Off" : headerLogger.mode == "D" ? "Debug" : "Error", // no itx
                },
              ]}
              onChange={(item) => {
                loggerArray.forEach((logger) => {
                  (logger.mode as any) = item[0].value;
                  (
                    document.getElementsByClassName(`log-${logger.className}`)[0].children[1] as HTMLInputElement
                  ).value = item[0].value;
                });
                Logger.allLoggerParents.set(headerLogger.className, item[0].value);

                if (setRefresh && refresh) setRefresh(refresh + 1);
                (document.getElementsByClassName(`log-addressGeneration`)[0].children[1] as HTMLInputElement).value =
                  item[0].value;
              }}
              color={dropDownColor}
              searchable={false}
              clearable={false}
            />
          </td>
        </tr>
      );
    }
    function LoggerRow(props: { logger: Logger; step: number }) {
      const { logger, step } = props;
      let name = logger.className.split(".")[0];
      name = name.split("/").pop() || name;

      const paddingLeft = `${step * 0.5 + 0.5}cm`;
      return (
        <tr>
          <td style={{ verticalAlign: "middle", paddingLeft: paddingLeft }}>
            &#x1F4C4;&nbsp;
            {name}
          </td>
          <td>
            <Dropdown
              name="logging"
              key={`${logger.className}.${logger.mode}`}
              className={`log-${logger.className} form-dropdown no-top-margin input-small`}
              options={[
                { value: "O", label: "Off" }, // no itx
                { value: "D", label: "Debug" }, // no itx
                { value: "E", label: "Error" }, // no itx
              ]}
              values={[
                {
                  value: logger.mode,
                  label: logger.mode == "O" ? "Off" : logger.mode == "D" ? "Debug" : "Error",
                },
              ]}
              onChange={(item) => {
                (logger.mode as any) = item[0].value;
                if (setRefresh && refresh) setRefresh(refresh + 1);
              }}
              color={dropDownColor}
              searchable={false}
              clearable={false}
            />
          </td>
        </tr>
      );
    }

    const loggerRows: any = [];
    let allLoggers = Logger?.allLoggers.sort((a, b) => {
      return a.className.toLowerCase() < b.className.toLowerCase() ? -1 : 1;
    });
    allLoggers = allLoggers.filter((logger) => logger.className.toLowerCase().includes(loggingFilter.toLowerCase()));

    loggerRows.push(<HeaderRow loggerArray={allLoggers} groupname="All" step={-1} />);
    const rowMap = new Map<string, Array<Logger>>();
    let header = ["", "", "", "", ""];
    allLoggers?.forEach((logger) => {
      const loggerStructure = logger.className.split("/");

      for (let i = 0; i < loggerStructure.length; i++) {
        const loggerGroup = rowMap.get(loggerStructure[i] as string) || new Array<Logger>();
        loggerGroup.push(logger);
        rowMap.set(loggerStructure[i] as string, loggerGroup);
        if (loggerStructure[i] != header[i]) {
          header[i] = loggerStructure[i];
          if (i != loggerStructure.length - 1) {
            let headerName = loggerStructure[0];
            for (let j = 1; j <= i; j++) {
              headerName = headerName + "/" + loggerStructure[j];
            }
            loggerRows.push(
              <HeaderRow
                loggerArray={rowMap.get(loggerStructure[i] as string) || new Array<Logger>()}
                groupname={headerName}
                step={i}
              />,
            );
          } else {
            loggerRows.push(<LoggerRow logger={logger} step={i} />);
          }
        }
      }
    });
    return (
      <table style={{ width: "max-content" }}>
        <tbody>{loggerRows}</tbody>
      </table>
    );
  }
  return (
    <SettingsPage handler="/settings/logging">
      <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
        <label className="form-label-bold" htmlFor="logging" key={"logging_label"} style={{ marginBottom: "10px" }}>
          {itx("SettingsScreen.loggingFilter", "Filter")}
          &nbsp; &nbsp;
          <input
            type="text"
            id="loggingFilter"
            name="loggingFilter"
            value={loggingFilter}
            onChange={(e) => setLoggingFilter(e.target.value)}
            className="input"
          />
        </label>
      </div>

      <LoggerElements />
    </SettingsPage>
  );
}
